import Button from "@material-ui/core/Button";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import React, { useMemo } from "react";

import { useI18n } from "@/features/common/hooks/useI18n";
import { useButtonStyles } from "@/features/common/styles";
import { useUserContext } from "@/features/user/contexts/useUserContext";
import {
  PostPagePostFragment,
  PostTypeEnum,
} from "@/generated/generated-hooks";
import { isThisMonthTz } from "@/helpers/common/dateTimeHelper";

type PostMaskSubscribeButtonProps = {
  variant: "image" | "article";
  post: PostPagePostFragment;
  onClick: (e: any) => void;
};

export const PostMaskSubscribeButton: React.FC<PostMaskSubscribeButtonProps> =
  ({ variant, post, onClick }) => {
    const { t } = useTranslation(["post", "subscriptionPlan"]);
    const { user } = useUserContext();

    const { formatWithLocale } = useI18n();
    const buttonClasses = useButtonStyles();

    const isVideo = post.postType === PostTypeEnum.Video;
    const { writerId, createdAt, publishAt } = post ?? {};

    const isThisMonth = useMemo(() => {
      if (!createdAt && !publishAt) return true;
      const createdDate = new Date(publishAt ?? createdAt);
      return isThisMonthTz(createdDate);
    }, [createdAt, publishAt]);

    const getHoverLabel = () => {
      if (isThisMonth)
        return isVideo
          ? t("post:imageCard.userVideoHoverLabel")
          : t("post:imageCard.userHoverLabel");

      return t("post:imageCard.unlockExpiredContent", {
        month: formatWithLocale({
          date: new Date(publishAt ?? createdAt),
          formatStr: "MMM",
        }),
      });
    };

    // /* skip or loading, no data yet */
    if (user?._id === writerId) return null;

    return (
      <>
        <span className="font-bold text-center my-4 mb-4">
          {getHoverLabel()}
        </span>

        <Button
          className={clsx(
            "mx-3",
            variant === "image" && buttonClasses.outlinedWhite,
          )}
          onClick={onClick}
          variant="outlined"
        >
          {t("post:imageCard.userHoverButtonLabel", { price: post?.price })}
        </Button>
      </>
    );
  };
